import { All } from "./All";
import { CreateEdit } from "./CreateEdit";

export const SmsSnippets = {
  All,
  Create: CreateEdit,
  Edit: CreateEdit,
};
